import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { palette, themeMode, spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';

const Autocomplete = styled(Box)`
    position: relative;
`;
const Divider = styled.div`
    display: none;
    align-items: center;
    justify-content: center;
    color: ${palette("neutral.500")};
    width: 100%;

    &:not(:last-child) {
        display: flex;
    }

    &:after,
    &:before {
        content: ' ';
        flex-grow: 1;
        height: 1px;
        background-color: ${themeMode({ light: palette("neutral.200"), dark: palette("neutral.700") })};
    }
`;
const SingleValueComponentContainer = styled(Box)`
    display: flex;
    align-items: center;
    position: absolute;
    padding: ${spacing("sm")};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
`;
const Styled = {
  Autocomplete,
  Divider,
  SingleValueComponentContainer
};

export { Styled };
//# sourceMappingURL=styled.es.js.map
